import { useEffect, useState } from "react";
import { postData } from "./Http/api";

const CasoEtapa = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await postData("/CasoEtapaListar", {});

        const data = response.value.map((item) => ({
          idCasoEtapa: item.idCasoEtapa,
          descripcion: item.descripcion
        }));

        setRows(data);
      } catch (ex) {
        console.error("Error cargando Etapas:", ex);
        setRows([]);
      }
    };

    fetchData();
  }, []);

  return rows;
};

// Named async helper for non-hook consumers
export const fetchCasoEtapas = async () => {
  try {
    const response = await postData("/CasoEtapaListar", {});
    return (response?.value || []).map((item) => ({
      idCasoEtapa: item.idCasoEtapa,
      descripcion: item.descripcion
    }));
  } catch (ex) {
    console.error("Error cargando Etapas (helper):", ex);
    return [];
  }
};

export default CasoEtapa;
